import { ApolloError, isApolloError } from "@apollo/client";

import { PickingConflictData } from "flows/Picking/components/PickingConflictModal";

const CONFLICT_ERROR_CODE = "PICKING_ORDER_CONFLICT";

export function isPickingConflictError(error: unknown): boolean {
  if (!(error instanceof Error) || !isApolloError(error)) return false;
  const code = (error as ApolloError).graphQLErrors?.[0]?.extensions?.code;
  return code === CONFLICT_ERROR_CODE;
}

export function extractConflictData(error: ApolloError): PickingConflictData | null {
  const meta = error.graphQLErrors?.[0]?.extensions?.meta as Record<string, unknown> | undefined;
  if (!meta) return null;

  const startedBy = meta.startedBy as { id: string; displayName?: string | null } | undefined;
  const finishedBy = meta.finishedBy as { id: string; displayName?: string | null } | undefined;
  const handoverContainerIds = (meta.handoverContainerIds as string[] | undefined) ?? [];
  const handoverShelfNumbers = (meta.handoverShelfNumbers as string[] | undefined) ?? [];

  return {
    pickingState: (meta.pickingState as string) ?? null,
    startedBy: startedBy
      ? {
          id: startedBy.id,
          displayName: startedBy.displayName ?? null,
        }
      : null,
    finishedBy: finishedBy
      ? {
          id: finishedBy.id,
          displayName: finishedBy.displayName ?? null,
        }
      : null,
    handoverDetails: {
      containerIds: handoverContainerIds,
      shelfNumbers: handoverShelfNumbers,
    },
  };
}
